module.exports = __webpack_public_path__ + "static/flags/PU-170a7b0535e7f9073c012489c8766695.gif";